import * as React from "react";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import {Button} from "reactstrap";
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import {
    FalconNavigatorHeader,
    productHelper,
    ProductsEnum,
    Quote,
    resourcesHelper
} from "@falcon/services";
import {authorize, IWithRouterProps, withRouter} from "@athena-portal/components";
import {BackButton} from "../../../../components/navigation/BackButton";
import {Link} from "react-router-dom";
import {NewQuotePageBase} from "./NewQuotePageBase";
import {AllianzOnlineBadge} from "../../../../components/AllianzOnlineBadge";

enum LvProducts {
    PET = "PET",
    TRAVEL = "TRAVEL"
}

enum Modals {
    ALLIANZ = "ALLIANZ",
    LV = "LV"
}

const productNameMap: Record<string, string> = {
    [ProductsEnum.WOLF_MOTOR]: "car",
    [ProductsEnum.HOME]: "home",
};

type AllProducts = ProductsEnum | LvProducts;

interface IGetNewQuotePageState {
    showModal?: Modals;
    selectedProduct?: AllProducts;
    selectedProductName: string;
    annualMotorQuotes: Quote[];
    annualHomeQuotes: Quote[];
}

@authorize
export class GetNewQuotePagePlain extends NewQuotePageBase<IWithRouterProps, IGetNewQuotePageState> {
    private readonly ANNUAL_MOTOR_ENABLED = process.env.REACT_APP_ANNUAL_MOTOR_ENABLED ? JSON.parse(process.env.REACT_APP_ANNUAL_MOTOR_ENABLED) : true;
    private readonly ANNUAL_HOME_ENABLED = process.env.REACT_APP_ANNUAL_HOME_ENABLED ? JSON.parse(process.env.REACT_APP_ANNUAL_HOME_ENABLED) : true;
    private readonly TRAVEL_INSURANCE_BANNER_ENABLED  = process.env.REACT_APP_TRAVEL_INSURANCE_BANNER_ENABLED  ? JSON.parse(process.env.REACT_APP_TRAVEL_INSURANCE_BANNER_ENABLED) : true;
    private readonly PET_INSURANCE_BANNER_ENABLED  = process.env.REACT_APP_PET_INSURANCE_BANNER_ENABLED  ? JSON.parse(process.env.REACT_APP_PET_INSURANCE_BANNER_ENABLED) : true;
    private readonly MOTOR_QUOTES_PAGE: string = "/dashboard/annualQuotes";
    private readonly HOME_QUOTES_PAGE: string = "/dashboard/HomeInsuranceQuotes";

    constructor(props: Readonly<IWithRouterProps>) {
        super(props);
        this.state = {
            showModal: undefined,
            selectedProduct: undefined,
            selectedProductName: "",
            annualMotorQuotes: [],
            annualHomeQuotes: [],
        };
    }

    public render() {
        return (
            <>
                <FalconHeader/>
                <div id="noPaddingBottomPlugin" className="plugin">
                    <AllianzOnlineBadge/>
                    <FalconNavigatorHeader back="/dashboard" title="Get a new quote"/>

                    {this.renderQuoteChoice()}
                    {this.renderRenewalDateCapturePanel()}
                </div>
                {this.renderLVQuotes()}
                <FalconFooter/>
                <GetNewQuoteModal
                    isOpen={this.state.showModal === Modals.ALLIANZ}
                    closeModal={this.closeModal}
                    navigateToPage={this.navigateToPage}
                    selectedProduct={this.state.selectedProduct}
                    selectedProductName={this.state.selectedProductName}
                />
                <GetLvQuoteModal
                    isOpen={this.state.showModal === Modals.LV}
                    closeModal={this.closeModal}
                    navigateToPage={this.navigateToPage}
                    selectedProduct={this.state.selectedProduct}
                />
            </>
        );
    }

    private renderLVQuotes = () => {
        // @ts-ignore
        const QuoteButton = ({ onClick, text }) => (
            <div className="get-quote-button">
                <Button onClick={onClick} className="btn btn-primary btn-next-no-arrow m-0-desktop">
                    {text}
                </Button>
            </div>
        );

        // @ts-ignore
        const QuoteHeader = ({ productType }) => (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className="product-title">LV= {productType} insurance</div>
                <div style={{ textAlign: 'right' }}>
                    <b>10%</b><br />
                    discount
                </div>
            </div>
        );

        const DiscountMobile = ({ discount }: { discount: number }) => (
            <div className="discount-mobile">
                <p>
                    <b>{discount}%</b>{" "}
                    <span className="small">online discount</span>
                </p>
            </div>
        );

        const DiscountDesktop = ({ discount }: { discount: number }) => (
            <div className="quote-right-column">
                <b>{discount}%</b>
                <p className="small">online discount</p>
            </div>
        );

        return (
                <div className="travel-pet-get-quote">
                    {(this.TRAVEL_INSURANCE_BANNER_ENABLED || this.PET_INSURANCE_BANNER_ENABLED) && (
                        <>
                            <div className="product-context-wide">
                                <div className="horizontal-positioner">
                                    {this.TRAVEL_INSURANCE_BANNER_ENABLED && (
                                        <div className="horizontal-panel-get-quote">
                                            <div>
                                                <img className="quote-flourish" src="/Allianz/img/travel-defaqto-flourish.svg"
                                                     alt="Defaqto 5 star rated Premier policy"/>
                                            </div>
                                            <DiscountMobile discount={20} />
                                            <div className="quote-mid-column">
                                                <div className="product-title">Allianz Travel Insurance</div>

                                                <p className="product-description">
                                                    Going on holiday? Take Allianz Travel Insurance with you. Cover the essentials with Bronze or choose our Defaqto 5 Star rated Silver or Gold cover levels. Save 10% when you buy online and an extra 10% as an existing Allianz customer.
                                                </p>
                                                <QuoteButton onClick={() => this.openModal(LvProducts.TRAVEL)}
                                                             text="Travel quote"/>
                                            </div>
                                            <DiscountDesktop discount={20} />
                                        </div>
                                        )}
                                    {this.PET_INSURANCE_BANNER_ENABLED && (
                                        <div className="horizontal-panel-get-quote">
                                            <div>
                                                <img className="quote-flourish" src="/Allianz/img/pet-defaqto-flourish.svg"
                                                     alt="Defaqto 5 star rated Pet policy"/>
                                            </div>
                                            <DiscountMobile discount={10} />
                                            <div className="quote-mid-column">
                                                <div className="product-title">LV= pet insurance</div>

                                                <p className="product-description">
                                                    We're here when your cats and dogs need more than a little TLC. Get a 10% discount on your first year of cover when you buy online.<br/>
                                                    Insure your pet with LV= by 30 November 2026 and we'll send you a £50 Amazon gift card (<a href="https://cloud.insurance.lv.co.uk/petxsellmarchtcs"
                                                       className="text-decoration-underline muli-bold-16" target="_blank" rel="noopener noreferrer">T&amp;Cs apply</a>).
                                                </p>
                                                <QuoteButton onClick={() => this.openModal(LvProducts.PET)} text="Pet quote"/>
                                            </div>
                                            <DiscountDesktop discount={10} />
                                        </div>
                                    )}
                                    <div className="lv-company-allianz">
                                        <img className="lv-company-allianz" src="/Allianz/img/LV-Allianz.png"/>
                                    </div>
                                </div>
                            </div>

                            <div className="before-footer">
                                <div className="horizontal-positioner" id="horizontal-positioner-back-button">
                                    <BackButton isTop={false} link={"/dashboard"}/>
                                </div>
                            </div>
                        </>
                    )}
                </div>
        )
    }

    private renderQuoteChoice = () => {
        return (
                <div className="get-quote-allianz mx-3">
                    {this.ANNUAL_MOTOR_ENABLED && this.renderAnnualMotorTile()}
                    {this.ANNUAL_HOME_ENABLED && this.renderAnnualHomeTile()}
                </div>
        )
    }

    private renderAnnualMotorTile = () => {
        const annualMotorQuoteCount: number = this.state.annualMotorQuotes.length;
        const hasAnnualMotorQuotes: boolean = annualMotorQuoteCount > 0;
        return (
            <div className="section-panel-get-quote">
                {this.renderMotorQuoteTile(annualMotorQuoteCount)}

                <div className="get-quote-button">
                    {hasAnnualMotorQuotes ? <Link to={this.MOTOR_QUOTES_PAGE} className="buttonLink w-100">
                            <button type="button"
                                    id={"test"}
                                    className="btn btn-primary m-0-desktop">
                                View your car quote(s)
                            </button>
                        </Link>
                        : <Button onClick={() => this.openModal(ProductsEnum.WOLF_MOTOR)}
                                  className="btn btn-primary btn-next-no-arrow m-0-desktop">Car quote</Button>}
                </div>
                <div className="quote-panel-view-quotes mt-4">
                    {hasAnnualMotorQuotes ? <Link className="text-decoration-underline muli-bold-16" to={'#'} onClick={() => this.openModal(ProductsEnum.WOLF_MOTOR)}>
                            Get a new car quote
                        </Link>
                        : <p className="mb-0">You don’t have any car quotes</p>
                    }
                </div>
            </div>
        );
    }

    private renderAnnualHomeTile = () => {
        const annualHomeQuoteCount: number = this.state.annualHomeQuotes.length;
        const hasHomeQuotes: boolean = annualHomeQuoteCount > 0;
        return (
            <div className="section-panel-get-quote">
                {this.renderHomeQuoteTile(annualHomeQuoteCount)}
                <div className="get-quote-button">
                    {hasHomeQuotes ? <Link to={this.HOME_QUOTES_PAGE} className="buttonLink w-100">
                            <button type="button"
                                    id={"test"}
                                    className="btn btn-primary m-0-desktop">
                                View your home quote
                            </button>
                        </Link>
                        : <Button onClick={() => this.openModal(ProductsEnum.HOME)}
                                  className="btn btn-primary btn-next-no-arrow m-0-desktop">Home quote</Button>}
                </div>
                <div className="quote-panel-view-quotes mt-4">
                    {hasHomeQuotes ? <Link className="text-decoration-underline muli-bold-16" to={'#'} onClick={() => this.openModal(ProductsEnum.HOME)}>
                                Get a new home quote
                            </Link>
                            : <p className="mb-0">You don’t have any home quotes</p>
                    }
                </div>

            </div>
        )
    }

    private isAllianz(productType: AllProducts): boolean {
        return (Object.values(ProductsEnum) as AllProducts[]).includes(productType);
    }

    private openModal = (productType: AllProducts) => {
        const showModal = this.isAllianz(productType) ? Modals.ALLIANZ : Modals.LV;

        this.setState({
            showModal,
            selectedProduct: productType,
            selectedProductName: productNameMap[productType] || "defaultName",
        })
    }

    private closeModal = () => {
        this.setState({showModal: undefined, selectedProduct: undefined})
    }

    private navigateToPage = () => {
        const homeQuickQuoteEnabled: boolean = process.env.REACT_APP_HOME_QUICK_QUOTE_ENABLED ? JSON.parse(process.env.REACT_APP_HOME_QUICK_QUOTE_ENABLED) : false;
        const product = this.state.selectedProduct;
        const entryPage: string = product === ProductsEnum.HOME && homeQuickQuoteEnabled ? "quickQuotePresetPage" : "dashboardEntryPage";

        if (product) {
            if (product === LvProducts.PET) {
                window.open("https://www.lv.com/promotion/pet-insurance-lvpet?utm_source=allianz&utm_medium=account&utm_campaign=petcrosssell&utm_content=get_a_quote",
                    '_blank',
                    'noopener')
            } else if (product === LvProducts.TRAVEL) {
                window.open("https://www.allianz.co.uk/insurance/travel-insurance.html",
                    '_blank',
                    'noopener');
            } else {
                this.props.navigate(`${productHelper.getNewBusinessUrl(product)}/${entryPage}`);
            }
        }
    }

}

interface IGetNewQuoteModalProps {
    isOpen: boolean;
    closeModal: () => void;
    navigateToPage: (event: any) => void;
    selectedProduct?: AllProducts;
    selectedProductName: string;
}

interface IGetLvQuoteModalProps {
    isOpen: boolean;
    closeModal: () => void;
    navigateToPage: (event: any) => void;
    selectedProduct: AllProducts | undefined;
}

const GetNewQuoteModal: React.FC<IGetNewQuoteModalProps> = ({isOpen, closeModal, navigateToPage, selectedProduct, selectedProductName}) => (
    <Modal className="custom-info-modal" isOpen={isOpen} toggle={closeModal} id="getNewQuoteModal">
        <ModalHeader toggle={closeModal}>
            <div className="d-flex">
                <img src="/img/Flow-info-selected.svg" alt="Info icon"/>
                <span
                    className="ml-3 text-blue-2 fs-20 font-weight-medium">Before getting a quote for a new {selectedProductName} policy...</span>
            </div>
        </ModalHeader>
        <ModalBody className="pt-0">
            {getModalBody(selectedProduct)}
        </ModalBody>
        <ModalFooter className="my-2 w-100">
            <button type="button" className="btn btn-primary btn-next-no-arrow w-100" onClick={navigateToPage}
                    id="accept-btn">Ok, I understand
            </button>
        </ModalFooter>
    </Modal>
);

function getModalBody(selectedProduct?: AllProducts) {
    if (selectedProduct === ProductsEnum.WOLF_MOTOR) {
        return (<>
            <p className="font-weight-semi-bold">Your existing account details will be used to create a new policy
                for your vehicle.<br/>The new policy will have:</p>
            <p className="font-weight-extra-light">● The same email address as the existing policy</p>
            <p className="font-weight-extra-light">● The same policyholder as the existing policy</p>
            <p className="font-weight-extra-light">● The same address as the existing policy</p>
            <p className="font-weight-extra-light">You'll use your existing account to access and manage this new
                policy. If any information is incorrect
                or needs updating, please update your existing policy before continuing</p>
            <p className="font-weight-extra-light">Alternatively, to set up a policy with a different policyholder,
                please <a href={"https://www.allianz.co.uk/insurance/car-insurance.html"}>start a new quote</a></p>
        </>);
    } else {
        return (<>
            <p className="font-weight-semi-bold pt-3">To get new policies in the existing account please check the
                following:</p>
            <p className="font-weight-extra-light">● The new policy use the same email address as the existing
                policy;</p>
            <p className="font-weight-extra-light">● The policyholder must have the same name and date of birth as on
                the existing policy;</p>
            <p className="font-weight-extra-light">● The policyholder must live at the same address as on the existing
                policy.</p>
        </>);
    }
}

const GetLvQuoteModal: React.FC<IGetLvQuoteModalProps> = ({isOpen, closeModal, navigateToPage, selectedProduct}) => {
    const isTravel = selectedProduct === LvProducts.TRAVEL;
    return (
        <Modal className="custom-info-modal travel-pet-get-quote" isOpen={isOpen} toggle={closeModal} id="getLvQuoteModal">
            <ModalHeader toggle={closeModal}>
                <div className="d-flex">
                    <img src="/img/Flow-info-selected.svg" alt="Info icon"/>
                    <span
                        className="ml-3 text-blue-2 fs-20 font-weight-medium">{isTravel ? "Buying a travel policy" : "Buying an LV= policy"}</span>
                </div>
            </ModalHeader>
            <ModalBody className="pt-0">
                {isTravel ?
                    <p className="font-weight-extra-light">Just so you know, if you buy travel insurance, it will appear in a new Allianz account, not in this one.</p> :
                    <p className="font-weight-extra-light">Just so you know, if you buy
                        LV= pet insurance, it won’t appear in
                        your {resourcesHelper.THEME} account. It’s a separate policy and LV= will send you everything you need.</p>}
            </ModalBody>
            <ModalFooter className="my-2 w-100">
                <button type="button" className="btn no-margin-top btn-back btn-next-no-arrow w-100"
                        onClick={closeModal}
                        id="accept-btn">Cancel
                </button>
                <button type="button" className="btn no-margin-top btn-primary btn-next-no-arrow w-100"
                        onClick={navigateToPage}
                        id="accept-btn">{isTravel ? "Travel quote" : "Pet quote"}
                </button>
            </ModalFooter>
        </Modal>
    );
};

export const GetNewQuotePage = withRouter(GetNewQuotePagePlain)
